import { apiClient } from '@/services/authApi';
import { endpoints } from '@/services/endpoints';

/** Response from GET /api/tax-year/default (operationId: getDefaultTaxYear) */
export interface DefaultTaxYearResponse {
  taxYear: number;
}

/** Response from GET /api/tax-year (operationId: getTaxYearConfig) */
export interface TaxYearConfigResponse {
  supportedYears: number[];
  defaultTaxYear: number;
}

const FALLBACK_MIN = 2010;
const FALLBACK_MAX = 2026;

/** Backend-aligned fallback when GET /api/tax-year fails */
export function getFallbackTaxYearConfig(): TaxYearConfigResponse {
  const supportedYears: number[] = [];
  for (let y = FALLBACK_MIN; y <= FALLBACK_MAX; y++) {
    supportedYears.push(y);
  }
  const calendarDefault = new Date().getFullYear() - 1;
  const defaultTaxYear = Math.min(
    FALLBACK_MAX,
    Math.max(FALLBACK_MIN, calendarDefault)
  );
  return { supportedYears, defaultTaxYear };
}

/**
 * Get supported tax years and default from the server.
 * Used to populate year selectors and preselect the default.
 */
export async function getTaxYearConfig(): Promise<TaxYearConfigResponse> {
  const response = await apiClient.get<TaxYearConfigResponse>(
    endpoints.taxYear.config
  );
  return response.data;
}

/**
 * Get the default tax year from the server.
 * Prefer getTaxYearConfig() when both the list and default are needed.
 */
export async function getDefaultTaxYear(): Promise<number> {
  const config = await getTaxYearConfig();
  return config.defaultTaxYear;
}
